/* eslint-disable prettier/prettier */

export const menuUA = [
  "menuUA/Str1.jpg",
  "menuUA/str2.jpg",
  "menuUA/str3.jpg",
  "menuUA/str4.jpg",
  "menuUA/str5.jpg",
  "menuUA/str6.jpg",
  "menuUA/str7.jpg",
  "menuUA/str8.jpg",
  "menuUA/str9.jpg",
  "menuUA/str10.jpg",
  "menuUA/str11.jpg",
  "menuUA/str12.jpg",
  "menuUA/str13.jpg",
]

export const menuEN = [
  "menuEN/Str1.jpg",
  "menuEN/str2.jpg",
  "menuEN/str3.jpg",
  "menuEN/str4.jpg",
  "menuEN/str5.jpg",
  "menuEN/str6.jpg",
  "menuEN/str7.jpg",
  "menuEN/str8.jpg",
  "menuEN/str9.jpg",
  "menuEN/str10.jpg",
  "menuEN/str11.jpg",
  "menuEN/str12.jpg",
  "menuEN/str13.jpg",
  "menuEN/str14.jpg",
]

export const alcogol = [
  "alcogol/Alkogol1.jpg",
  "alcogol/Alkogol2.jpg",
  "alcogol/Alkogol3.jpg",
  "alcogol/Alkogol4.jpg",
]

export const banquet = [
  "banquet/banquet0.jpg",
  "banquet/banquet1.jpg",
  "banquet/banquet2.jpg",
  "banquet/banquet3.jpg",
]

export const asianCuisine = [
  "asianCuisine/asianMenu1.jpg",
  "asianCuisine/asianMenu2.jpg",
  "asianCuisine/asianMenu3.jpg",
  "asianCuisine/asianMenu4.jpg",
  "asianCuisine/asianMenu5.jpg",
  "asianCuisine/asianMenu6.jpg",
  "asianCuisine/asianMenu7.jpg",
  "asianCuisine/asianMenu8.jpg",
  "asianCuisine/asianMenu9.jpg",
  "asianCuisine/asianMenu10.jpg",
  "asianCuisine/asianMenu11.jpg",
  "asianCuisine/asianMenu12.jpg",
  "asianCuisine/asianMenu13.jpg",
  "asianCuisine/asianMenu14.jpg",
  "asianCuisine/asianMenu15.jpg",
  "asianCuisine/asianMenu16.jpg",
  "asianCuisine/asianMenu17.jpg",
  "asianCuisine/asianMenu18.jpg",
  "asianCuisine/asianMenu19.jpg",
  "asianCuisine/asianMenu20.jpg",
  "asianCuisine/asianMenu21.jpg",
  "asianCuisine/asianMenu22.jpg",
  "asianCuisine/asianMenu23.jpg",
  "asianCuisine/asianMenu24.jpg",
  "asianCuisine/asianMenu25.jpg",
  "asianCuisine/asianMenu26.jpg",
]

export const wine = ["wine/redWine.jpg", "wine/whiteWine.jpg"]

export const barCard = [
  "barCard/barCard1.jpg",
  "barCard/barCard2.jpg",
  "barCard/barCard3.jpg",
  "barCard/barCard4.jpg",
  "barCard/barCard5.jpg",
  "barCard/barCard6.jpg",
  "barCard/barCard7.jpg",
  "barCard/barCard8.jpg",
]
